"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAllCards = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

var getAllCards = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(jwt) {
    var response, stripeCards;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return (0, _axios.default)({
              method: "get",
              url: "".concat(process.env.REACT_APP_CARDS_ENDPOINT),
              headers: {
                Authorization: jwt
              }
            });

          case 3:
            response = _context.sent;
            stripeCards = JSON.parse(response.data.body).data;
            return _context.abrupt("return", stripeCards);

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            console.log(_context.t0);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));

  return function getAllCards(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.getAllCards = getAllCards;